import { Injectable } from '@angular/core';
import { IbanValidationGateway } from './iban-validation.gateway';
import { firstValueFrom } from 'rxjs';
import { IApiResponse } from '@web/shared-types';
import { IbanString, IIbanAllowed } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class IbanValidationService {
  private readonly gateway: IbanValidationGateway = new IbanValidationGateway();

  public async isSepaCountryCode(countryCode: string): Promise<boolean> {
    const response: IApiResponse<boolean> = await firstValueFrom(
      this.gateway.validateIbanCountry(countryCode)
    );
    return response.message?.type === 'error' ? false : !!response.data;
  }

  public async isNotBlacklisted(iban: IbanString): Promise<boolean> {
    const response: IApiResponse<IIbanAllowed> = await firstValueFrom(
      this.gateway.validateIbanAgainstBlacklist(iban)
    );
    return response.message?.type === 'error'
      ? false
      : !!response.data?.isIbanAllowed;
  }
}
